import React, { useState } from 'react'

import Box from 'components_new/atoms/Box'
import LoadingSpinner from 'components_new/atoms/LoadingSpinner'

import ExportTableWidgetTable from 'components_new/organisms/Widget/Types/Table/ExportTableWidgetTable'

import {
  FormattedWidgetData,
  isExportTableWidgetFullyLoaded,
  TExportTableWidget,
  WidgetOrder
} from 'types/GlobalWidget'

import { isFormattedData } from 'utils/widgetData'

interface ExportTableProps {
  formattedData: FormattedWidgetData | null
  widget: TExportTableWidget | null
}

const ExportTable = (props: ExportTableProps) => {
  const [order, setOrder] = useState<WidgetOrder>({
    id: null,
    index: null,
    dir: 'asc'
  })

  const { widget, formattedData } = props

  if (
    !widget ||
    !isExportTableWidgetFullyLoaded(widget) ||
    !isFormattedData(formattedData)
  ) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '400px',
          width: '100%'
        }}
      >
        <LoadingSpinner />
      </Box>
    )
  }

  return (
    <ExportTableWidgetTable
      formattedData={formattedData}
      isComparativeButIllegal={false}
      order={order}
      setOrder={setOrder}
      widget={widget}
    />
  )
}

export default ExportTable
